import { isBrowser } from './is-browser'

type WebviewValues = 'AppleOS' | 'ANDROID' | undefined

/**
 * Variable mise en local storage par l'équipe Vega pour qu'on puisse detecter facilement si on est sur une webview provenant de l'app.
 */
const WEBVIEW_KEY = 'is_webview'

const getIsWebview = (): WebviewValues =>
  isBrowser ? (localStorage.getItem(WEBVIEW_KEY) as WebviewValues) : undefined

export const isIosWebview = () => getIsWebview() === 'AppleOS'

export const isNotIosWebview = () => !isIosWebview()

export const getLinkTargetAttribute = () =>
  isNotIosWebview() ? '_blank' : undefined
